module.exports = __webpack_public_path__ + "static/media/banner-geradores-eolicos.6f4e098a.jpg";